import React, { useState } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import modalsComponents from "../../../../components/modals";

import authServices from "../../../../services/auth";
import userServices from "../../../../services/user";

import global from "../../../../config/global";


const DangerZone = () => {
  const { PasswordConfirmModal } = modalsComponents;
  const { t } = useTranslation();
  const [confirmDeleteAccountVisible, setConfirmDeleteAccountVisible] = useState(false);

  const [callingAPI, setCallingAPI] = useState(false);

  const handleDeleteAccount = async (password) => {
    setCallingAPI(true);
    const keyHash = await global.jsCore.cryptoService.hashPassword(password, null)
    await userServices.delete_me({ master_password_hash: keyHash })
      .then(async () => {
        global.pushSuccess(t('notification.success.account_details.deleted'));
        await authServices.logout(false);
      }).catch((error) => {
        global.pushError(error)
      }
    )
    setCallingAPI(false);
  }

  return (
    <div>
      <Card bodyStyle={{ padding: 16 }} className="mb-4">
        <div className="flex justify-between">
          <p className="font-semibold text-danger">
            {t('account_details.danger_zone.delete_account')}
          </p>
          <Button
            type='primary'
            danger
            ghost
            onClick={() => setConfirmDeleteAccountVisible(true)}
          >
            {t('account_details.danger_zone.delete_account')}
          </Button>
        </div>
        <p className="mt-1">
          {t('account_details.danger_zone.delete_account_desc')}
        </p>
      </Card>
      <PasswordConfirmModal
        width={480}
        visible={confirmDeleteAccountVisible}
        title={t('account_details.danger_zone.delete_account')}
        description={
          <div>
            <div className="my-4 locker-callout danger">
              <p className="font-semibold">
                {t('account_details.danger_zone.delete_locker_account')}
              </p>
              <p>
                {t('account_details.danger_zone.delete_locker_account_desc')}
              </p>
            </div>
            <p>{t('password_confirm.confirm_note')}</p>
          </div>
        }
        okText={t('button.delete_account')}
        callingAPI={callingAPI}
        danger={true}
        onConfirm={handleDeleteAccount}
        onClose={() => setConfirmDeleteAccountVisible(false)}
      />
    </div>
  );
}

export default DangerZone;